package org.example.willfreightnew.components.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.browser.dom.ElementTarget
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.CloseIcon
import com.varabyte.kobweb.silk.components.icons.HamburgerIcon
import com.varabyte.kobweb.silk.components.icons.MoonIcon
import com.varabyte.kobweb.silk.components.icons.SunIcon
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.overlay.OverlayVars
import com.varabyte.kobweb.silk.components.overlay.PopupPlacement
import com.varabyte.kobweb.silk.components.overlay.Tooltip
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.willfreightnew.NavLinkStyle
import org.jetbrains.compose.web.css.*
import org.example.willfreightnew.components.widgets.IconButton
import org.example.willfreightnew.toSitePalette
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.example.willfreightnew.components.util.Res
import org.example.willfreightnew.components.models.Section
import org.example.willfreightnew.components.util.Constants
import org.example.willfreightnew.HeaderLinkStyle
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import kotlinx.browser.window

//@Composable
//fun Header(onMenuClicked: () -> Unit) {
//    val breakpoint = rememberBreakpoint()
//    Row(
//        modifier = Modifier
//            .fillMaxWidth(if (breakpoint > Breakpoint.MD) 80.percent else 90.percent)
//            .margin(topBottom = 5.cssRem),
//        horizontalArrangement = Arrangement.SpaceBetween,
//        verticalAlignment = Alignment.CenterVertically
//    ) {
//        LeftSide()
//        RightSide()
//    }
//}

//@Composable
//fun LeftSide(
//) {
//    Row(verticalAlignment = Alignment.CenterVertically) {
//        Image(
//            src = Res.Image.LOGO,
//            description = "Will Freight"
//
//        )
//    }
//}
//
//@Composable
//fun RightSide() {
//    Row(
//        modifier = Modifier
//            .fillMaxWidth()
//            .borderRadius(r = 50.px)
//            .color(ColorMode.current.toSitePalette().nearBackground)
//            .padding(all = 20.px)
//    ) {
//        Section.values().take(3).forEach { section ->
//            Link(
//                modifier = Modifier
//                    .padding(right = 30.px)
//                    .fontFamily(Constants.FONT_FAMILY)
//                    .fontSize(0.75.cssRem)
//                    .fontWeight(FontWeight.Normal),
//                path = section.path,
//                text = section.title,
//            )
//        }
//    }
//}

val NavHeaderStyle = CssStyle.base {
    Modifier
        .fillMaxWidth(90.percent)
        .padding(all = 50.px)
        .borderRadius(r = 30.px)
}

@Composable
private fun NavLink(path: String, text: String) {
    Link(path,
        text,
        modifier = NavLinkStyle.toModifier(),
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant))
}

@Composable
private fun HeaderLink(path: String, text: String) {
    Link(path,
        text,
        modifier = HeaderLinkStyle.toModifier(),
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant))
}

@Composable
private fun MenuItems() {
    Section.entries.forEach { section ->
        HeaderLink(path = section.path, text = section.caps)
    }
}

@Composable
private fun SideMenuItems(onClick: () -> Unit) {
    HeaderLink("#home", "Home")
    HeaderLink("#about", "About")
    HeaderLink("#services", "Services")
    HeaderLink("#contact", "Contact Us")
}

@Composable
private fun ColorModeButton() {
    var colorMode by ColorMode.currentState
    IconButton(onClick = { colorMode = colorMode.opposite },) {
        if (colorMode.isLight) MoonIcon() else SunIcon()
    }
    Tooltip(ElementTarget.PreviousSibling, "Toggle color mode", placement = PopupPlacement.BottomRight)
}

@Composable
private fun HamburgerButton(onClick: () -> Unit) {
    IconButton(onClick) {
        HamburgerIcon()
    }
}

@Composable
private fun CloseButton(onClick: () -> Unit) {
    IconButton(onClick) {
        CloseIcon(Modifier.color(Colors.White))
    }
}

val SideMenuSlideInAnim = Keyframes {
    from {
        Modifier.translateX(100.percent)
    }

    to {
        Modifier
    }
}

// Note: When the user closes the side menu, we don't immediately stop rendering it (at which point it would disappear
// abruptly). Instead, we start animating it out and only stop rendering it when the animation is complete.
enum class SideMenuState {
    CLOSED,
    OPEN,
    CLOSING;

    fun close() = when (this) {
        CLOSED -> CLOSED
        OPEN -> CLOSING
        CLOSING -> CLOSING
    }
}

@Composable
fun NavHeader() {
    HeaderContent()
}

//@Composable
//fun NavHeader() {
//    Row(Modifier
//        .fillMaxWidth(90.percent)
//        .margin(all = 25.px)
//        .padding(left = 35.px, right = 35.px)
//        .borderRadius(r = 50.px)
//        .backgroundColor(ColorMode.current.toSitePalette().nearBackground),
//        verticalAlignment = Alignment.CenterVertically) {
//
//        Link("/", Modifier) {
//            /* Block display overrides inline display of the <img> tag, so it calculates centering better */
//            Image(Res.Image.LOGO,
//                "Will Freight Services Logo",
//                Modifier
//                    .height(6.cssRem)
//                    .display(DisplayStyle.Block))
//        }
//
//        Spacer()
//
//        Row(Modifier
//            .gap(1.5.cssRem)
//            .displayIfAtLeast(Breakpoint.MD),
//            verticalAlignment = Alignment.CenterVertically)
//        {
//            MenuItems()
//            ColorModeButton()
//        }
//
////***SIDE MENU LOGIC***
//        Row(
//            Modifier
//                .fontFamily(Constants.FONT_FAMILY)
//                .fontSize(1.5.cssRem)
//                .gap(1.cssRem)
//                .displayUntil(Breakpoint.MD),
//            verticalAlignment = Alignment.CenterVertically
//        ) {
//            var menuState by remember { mutableStateOf(SideMenuState.CLOSED) }
//
//            ColorModeButton()
//            HamburgerButton(onClick =  { menuState = SideMenuState.OPEN })
//
//            if (menuState != SideMenuState.CLOSED) {
//                SideMenu(
//                    menuState,
//                    close = { menuState = menuState.close() },
//                    onAnimationEnd = { if (menuState == SideMenuState.CLOSING) menuState = SideMenuState.CLOSED }
//                )
//            }
//        }
//    }
//}

@Composable
fun HeaderContent() {
    val breakpoint = rememberBreakpoint()
    var scroll: Double? by remember { mutableStateOf(null) }

    // Deprecated back to top button logic
    LaunchedEffect(Unit) {
        window.addEventListener(type = "scroll", callback = {
            scroll = document.documentElement?.scrollTop
        })
    }

    // Nav bar
    Box(
        modifier = Modifier
            .displayUntil(Breakpoint.MD)
            .height(2.px)
            .opacity(75.percent)
            .width(1000.percent)
            .backgroundColor(ColorMode.current.toSitePalette().brand.accent),
        contentAlignment = Alignment.BottomCenter
    )

    Row(
        Modifier
            .fillMaxWidth(100.percent)
            .backgroundColor(ColorMode.current.toSitePalette().background),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(Modifier.fillMaxWidth()) {
            Link(
                "/", Modifier
                    // .margin(left = 15.percent)
            ) {
                /* Block display overrides inline display of the <img> tag, so it calculates centering better */
                Image(
                    Res.Image.LOGO,
                    "Will Freight Services Logo",
                    Modifier
                        .displayIfAtLeast(Breakpoint.MD)
                        .height(7.5.cssRem)
                        .display(DisplayStyle.Block)
                        .padding(all = 5.px)
                        .padding(topBottom = 10.px)
                        .margin(left = 35.percent)
                )

                // Mobile version
                Image(
                    Res.Image.LOGO,
                    "Will Freight Services Logo",
                    Modifier
                        .displayUntil(Breakpoint.MD)
                        .height(3.cssRem)
                        .display(DisplayStyle.Block)
                        .padding(right = 50.px)
                )
            }
        }
        Row(Modifier
            .displayIfAtLeast(Breakpoint.LG)
            .margin(top = 5.px, right = 10.percent)
            .fontSize(14.px)
            .fillMaxWidth(35.percent)
            .color(ColorMode.current.toSitePalette().brand.primary)
            .align(Alignment.Top)) {
            SpanText("Phone : 02894 429990")
            Spacer()
            SpanText("Email : info@willfreight.co.uk")
        }
        Column(Modifier
            .margin(right = 150.px)
            .displayIfAtLeast(Breakpoint.MD)
            .opacity(30.percent)
        ) {
            ColorModeButton()
        }


        //***SIDE MENU LOGIC***
        Row(
            Modifier
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(1.5.cssRem)
                .gap(1.cssRem)
                .displayUntil(Breakpoint.MD)
                .padding(),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            var menuState by remember { mutableStateOf(SideMenuState.CLOSED) }

            ColorModeButton()
            HamburgerButton(onClick = { menuState = SideMenuState.OPEN })

            if (menuState != SideMenuState.CLOSED) {
                SideMenu(
                    menuState,
                    close = { menuState = menuState.close() },
                    onAnimationEnd = { if (menuState == SideMenuState.CLOSING) menuState = SideMenuState.CLOSED }
                )
            }
        }
    }

    // Main menu bar
    Row(
        Modifier
            .fontSize(0.95.cssRem)
            .gap(8.percent)
            .displayIfAtLeast(Breakpoint.MD)
            .padding(top = 11.px, bottom = 11.px)
            .fillMaxWidth(100.percent)
            .backgroundColor(rgb(175, 0, 0))
            .boxShadow(0.px, offsetY = 3.px, spreadRadius = (-2).px, blurRadius = 7.5.px),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    )
    {
        MenuItems()
    }
}

//@OptIn(DelicateApi::class)
//@Composable
//fun SideMenu(onMenuClosed: () -> Unit) {
//    val scope = rememberCoroutineScope()
//    val breakpoint = rememberBreakpoint()
//    var translateX by remember { mutableStateOf((-100).percent) }
//    var opacity by remember { mutableStateOf(0.percent) }
//
//    LaunchedEffect(breakpoint) {
//        translateX = 0.percent
//        opacity = 100.percent
//        if(breakpoint > Breakpoint.MD) {
//            scope.launch {
//                translateX = (-100).percent
//                opacity = 0.percent
//                delay(duration = 500.milliseconds)
//                onMenuClosed()
//            }
//        }
//    }
//}


@Composable
fun SideMenu(menuState: SideMenuState, close: () -> Unit, onAnimationEnd: () -> Unit) {
    Overlay(
        Modifier
            .setVariable(OverlayVars.BackgroundColor, Colors.Transparent)
            .onClick { close() }
    ) {
        key(menuState) { // Force recompute animation parameters when close button is clicked

            Column(
                Modifier
                    .fillMaxHeight()
                    .width(clamp(10.cssRem, 35.percent, 14.cssRem))
                    .borderRadius(1.percent)
                    .boxShadow(offsetX = 5.px, 0.px, blurRadius = 2.cssRem, spreadRadius = 2.cssRem)
                    .align(Alignment.CenterEnd)
                    // Close button will appear roughly over the hamburger button, so the user can close
                    // things without moving their finger / cursor much.
                    .padding(top = 1.cssRem, leftRight = 1.cssRem)
                    .gap(1.5.cssRem)
                    .backgroundColor(rgb(175, 0, 0))
                    .animation(
                        SideMenuSlideInAnim.toAnimation(
                            duration = 200.ms,
                            timingFunction = if (menuState == SideMenuState.OPEN) AnimationTimingFunction.EaseOut else AnimationTimingFunction.EaseIn,
                            direction = if (menuState == SideMenuState.OPEN) AnimationDirection.Normal else AnimationDirection.Reverse,
                            fillMode = AnimationFillMode.Forwards
                        )
                    )
                    .onClick { it.stopPropagation() }
                    .onAnimationEnd { onAnimationEnd() },
                horizontalAlignment = Alignment.CenterHorizontally,

            ) {
                Column(Modifier.align(Alignment.End)) {CloseButton(onClick = { close() })}

                Column(Modifier.padding(right = 0.75.cssRem).gap(1.5.cssRem).fontSize(1.4.cssRem), horizontalAlignment = Alignment.End) {
                    SideMenuItems(onClick = { close() })
                }
            }
        }
    }
}
